import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';
import { useRouterActions } from 'react-resource-router';
import { DropdownItem } from '@atlaskit/dropdown-menu';
import { useTemplateFormApi } from '../../../../../../services/template-form-api';
import { messages } from './messages';
export const DuplicateFormAction = ({
  form
}) => {
  const {
    push
  } = useRouterActions();
  const intl = useIntl();
  const templateFormApi = useTemplateFormApi();
  const handleDuplicateForm = formToCopy => {
    templateFormApi.copyTemplateForm(formToCopy.id, form.projectId, form.projectId,
    // duplicating to same project
    intl.formatMessage(messages.copyNewFormName, {
      formName: formToCopy.name
    })).then(response => {
      push(response.nextUrl);
    });
  };
  return /*#__PURE__*/React.createElement(DropdownItem, {
    onClick: () => handleDuplicateForm(form)
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.duplicateLabel));
};